import './App.css'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Dialog, DialogTrigger, DialogContent } from './pages/Dialog/Dialog'
import Intro from './pages/Intro'
import About from './pages/About'
import Header from './pages/Header'
import Contact from './components/Contact'
import Music from './pages/Music'
import Footer from './pages/Footer'
import ContactPage from './pages/ContactPage'
// import "animate.css";

function App() {
	const [formStatus, setFormStatus] = useState('standby')

	useEffect(() => {
		if (window.location.pathname !== '/')
			window.location.href = window.location.origin
	}, [window.location])
	return (
		<Dialog>
			<Header DialogTrigger={DialogTrigger} formStatus={formStatus} />
			<DialogContent aria-label={'Contact form'}>
				<ContactWrapper>
					<Contact
						dialog={true}
						formStatus={formStatus}
						setFormStatus={setFormStatus}
					/>
				</ContactWrapper>
			</DialogContent>
			<ContentWrap>
				<Intro DialogTrigger={DialogTrigger} formStatus={formStatus} />
				<Music DialogTrigger={DialogTrigger} />
				<About DialogTrigger={DialogTrigger} />
				<ContactPage
					DialogTrigger={DialogTrigger}
					formStatus={formStatus}
					setFormStatus={setFormStatus}
				/>
			</ContentWrap>
			<Footer />
		</Dialog>
	)
}

const ContentWrap = styled.div`
	max-width: 100vw;
	margin-top: 8vh;
`
const ContactWrapper = styled.div`
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(calc(-50% - 7px), -50%);
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`

export default App
